import Handlebars from 'handlebars';

const getNotificationMessage = (message, data) => {
    try {
        return Handlebars.compile(message)(data);
    } catch (error) {
        return '';
    }
};

export default getNotificationMessage;
